import React from "react";
import { motion } from "framer-motion";
import "./App.css";

function App() {
  return (
    <div className="flex justify-center items-center min-h-screen bg-gradient-to-b from-gray-900 via-black to-gray-900 bg-[radial-gradient(circle_at_center,_rgba(255,255,255,0.04),_transparent_80%)]">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-black bg-opacity-80 p-8 rounded-2xl shadow-xl text-white text-center max-w-md w-full"
      >
        <h2 className="text-2xl font-bold mb-3 drop-shadow-[0_1px_10px_rgba(255,255,255,0.2)]">
          Don’t say I didn’t warn you.
        </h2>
        <p className="mb-5 text-sm text-gray-300">
          This isn’t for everyone. But you’re not everyone.
        </p>

        {/* 🔗 Access Section */}
        <h3 className="text-lg font-semibold mb-3">Choose Your Access</h3>
        <div className="space-y-4 mb-6">
          <a
            href="https://t.me/+5yLPLXhvcrdjMjE5"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-blue-500 text-white py-3 rounded-lg font-semibold shadow-md hover:bg-blue-600 transition"
          >
            Join Telegram
          </a>
          <a
            href="https://onlyfans.com/sourmelonsoda"
            target="_blank"
            rel="noopener noreferrer"
            className="block bg-purple-600 text-white py-3 rounded-lg font-semibold shadow-md hover:bg-purple-700 transition"
          >
            OnlyFans
          </a>
        </div>

        {/* 💸 Contribution Section */}
        <h3 className="text-lg font-semibold mb-3">Send Something Real</h3>
        <div className="space-y-4">
          <a
            href="https://cash.app/$melonsoursoda"
            className="block bg-white text-black py-3 rounded-lg font-semibold shadow-md hover:bg-gray-300 transition"
          >
            CashApp
          </a>
          <a
            href="https://venmo.com/u/sourmelonsoda"
            className="block bg-white text-black py-3 rounded-lg font-semibold shadow-md hover:bg-gray-300 transition"
          >
            Venmo
          </a>
          <a
            href="http://paypal.me/sourmelonsoda"
            className="block bg-white text-black py-3 rounded-lg font-semibold shadow-md hover:bg-gray-300 transition"
          >
            PayPal
          </a>
        </div>
      </motion.div>
    </div>
  );
}

export default App;
